var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Box, ButtonBase, Typography } from "@mui/material";
import { useCallback, useState } from "react";
import { useWebgate } from "@xvia/webgate-connect";
import useLoading from "../../hooks/Loading";
import { handleServiceAssessment } from "../../util/evaluation";
export default function EvaluationButton(_a) {
    var idService = _a.idService;
    var accessToken = useWebgate().accessToken;
    var loading = useLoading();
    var _b = useState(""), error = _b[0], setError = _b[1];
    var handleClickServiceAssessment = useCallback(function () {
        handleServiceAssessment(loading, accessToken, setError, idService);
    }, [loading, accessToken, setError]);
    return (_jsx(Box, __assign({ sx: { p: 3, display: "flex", justifyContent: "center" } }, { children: error ? (_jsx(Typography, __assign({ sx: function (theme) { return ({
                color: theme.palette.error.main,
            }); } }, { children: error }))) : (_jsx(ButtonBase, __assign({ disableRipple: true, onClick: function () { return null; } }, { children: _jsx(Typography, __assign({ sx: function (theme) { return ({
                    cursor: "pointer",
                    color: theme.palette.primary.main,
                    "&:hover": {
                        color: theme.palette.primary.dark,
                    },
                }); } }, { children: "Avalia\u00E7\u00E3o do Servi\u00E7o" })) }))) })));
}
